import React from "react";
import License from "./License";

const FullAttribution = () => {
    return (
        <div className="fullAttribution">
            <span>
                <License />
            </span>
            <span>
                <p>Associate Producers - Ian Hamilton</p>
                <p>Publishing - Richard Kelly</p>
                <p>Designer - Ian Hamilton</p>
                <p>Designer's Assistant - Richard Kelly</p>
                <p>Additional Design - Zach Card, Ian Hamilton, Krischa, Beate Schulz, Jonas Wittmann</p>
                <p>Lead Editor - Richard Kelly</p>
                <p>Assistant Editors - Zach Card, Ian Hamilton, Krischa, Beate Schulz, Jonas Wittmann</p>
                <p>Artwork - Francita Soto, Jonas Wittmann</p>
                <p>Graphic Design - Francita Soto, Jonas Wittmann</p>
                <p>Layout - Richard Kelly</p>
                <p>Playtesters - Zach Card, Ian Hamilton, Krischa, Beate Schulz, Jonas Wittmann</p>
                <p>Special Thanks - SWAMP BEING</p>
            </span>
        </div>
    )
}

export default FullAttribution